import { render, staticRenderFns } from "./RecipesAll.vue?vue&type=template&id=5d15d41e&"
import script from "./RecipesAll.vue?vue&type=script&lang=js&"
export * from "./RecipesAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports